import { render } from "./LearningGoalsAllComponent.vue?vue&type=template&id=09daebc9&scoped=true"
import script from "./LearningGoalsAllComponent.vue?vue&type=script&lang=js"
export * from "./LearningGoalsAllComponent.vue?vue&type=script&lang=js"

import "./LearningGoalsAllComponent.vue?vue&type=style&index=0&id=09daebc9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09daebc9"]])

export default __exports__